import { ONBOARDING_STEP } from 'src/data/onboarding';
import { SPOTLIGHT_TYPE } from '../components/Spotlight';
import { buildTarget } from './utils';

export const STEPS_CO_DATA = [
  {
    id: ONBOARDING_STEP.coAssets,
    target: buildTarget([
      '[data-onboarding="ProjectOptimizationView"]',
      '[data-onboarding="ViewAssets"]',
      '[data-onboarding="Asset"]:first-of-type',
      '[data-onboarding="AssetPreview"]',
    ]),
    content: {
      title: 'Assets',
      description:
        'These are copy assets that we’ve extracted from your landing page. To add additional assets, click on the ‘Find more assets’ button at the bottom of the screen.',
    },
    options: {
      placement: 'bottom-start',
      showOverlay: true,
      spotlights: [
        { type: SPOTLIGHT_TYPE.rounded },
        {
          target: buildTarget([
            '[data-onboarding="ProjectOptimizationView"]',
            '[data-onboarding="ViewAssets"]',
            '[data-onboarding="Asset"]:first-of-type',
            '[data-onboarding="ListItemVariant"]',
          ]),
          type: SPOTLIGHT_TYPE.rounded,
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEP.coAssetTypeClassification,
    target: buildTarget([
      '[data-onboarding="ProjectOptimizationView"]',
      '[data-onboarding="ViewAssets"]',
      '[data-onboarding="Asset"]:first-of-type',
      '[data-onboarding="AssetTypeClassification"]',
    ]),
    content: {
      title: 'Asset Type Classification',
      description: 'To start working on an asset select its asset type.',
    },
    options: {
      placement: 'right-start',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.rounded }],
    },
  },
  {
    id: ONBOARDING_STEP.coGenerateNewVariations,
    target: buildTarget([
      '[data-onboarding="ProjectOptimizationView"]',
      '[data-onboarding="ViewAssets"]',
      '[data-onboarding="Asset"]:first-of-type',
      '[data-onboarding="GenerateNewVariations"]',
    ]),
    content: {
      title: 'Generate New Variations',
      description:
        'After classifying an asset, select a writing style and generate new text variations for this asset and save the ones you like.',
    },
    options: {
      placement: 'left-start',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.rounded }],
    },
  },
  {
    id: ONBOARDING_STEP.coPreviews,
    target: buildTarget([
      '[data-onboarding="ProjectOptimizationView"]',
      '[data-onboarding="ViewAssets"]',
      '[data-onboarding="Asset"]:first-of-type',
      '[data-onboarding="AssetPreview"]',
    ]),
    content: {
      title: 'Previews',
      description:
        'Hover over saved copy variations to see a preview of how they’ll look on your landing page.',
    },
    options: {
      placement: 'bottom-start',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.rounded }],
    },
  },
  {
    id: ONBOARDING_STEP.coPredictiveScore,
    target: buildTarget([
      '[data-onboarding="ProjectOptimizationView"]',
      '[data-onboarding="ViewAssets"]',
      '[data-onboarding="Asset"]:first-of-type',
      '[data-onboarding="ListItemVariant"]',
      '[data-onboarding="Score"]',
    ]),
    content: {
      title: 'Predictive Performance Score',
      description:
        'Anyword’s score evaluates copy according to its potential to engage. \n' +
        'Use it to get immediate feedback, optimize your copy, and make better decisions.ֿ',
    },
    options: {
      placement: 'bottom-end',
      showOverlay: true,
      spotlights: [{ type: SPOTLIGHT_TYPE.circle }],
    },
  },
  {
    id: ONBOARDING_STEP.coScoreHistogram,
    target: buildTarget(['[data-onboarding="AgeGenderHistogram"]']),
    content: {
      title: 'Score Histogram',
      description:
        "Hover over a score to see a breakdown of the demographics it's most likely resonate with.",
    },
    options: {
      placement: 'left',
      showOverlay: true,
      spotlights: [
        { type: SPOTLIGHT_TYPE.rounded, padding: 0 },
        {
          target: buildTarget([
            '[data-onboarding="ProjectOptimizationView"]',
            '[data-onboarding="ViewAssets"]',
            '[data-onboarding="Asset"]:first-of-type',
            '[data-onboarding="ListItemVariant"]',
            '[data-onboarding="Score"]',
          ]),
          type: SPOTLIGHT_TYPE.circle,
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEP.coContinuousOptimizationToggle,
    target: buildTarget(['[data-onboarding="ContinuousOptimizationToggle"]']),
    content: {
      title: 'Continuous Optimization',
      description:
        'Once variations were saved, toggle the switch to use this asset for continuous optimization. \n' +
        'Continuous Optimization monitors the performance of each copy variation on your landing page, learns from your actual visitors and shows the most successful combinations for every traffic source to optimize your conversions.\n',
    },
    options: {
      placement: 'left',
      showOverlay: true,
      spotlights: [
        { type: SPOTLIGHT_TYPE.rounded, padding: 0 },
        {
          target: buildTarget([
            '[data-onboarding="ProjectOptimizationView"]',
            '[data-onboarding="ViewAssets"]',
            '[data-onboarding="Asset"]:first-of-type',
            '[data-onboarding="ContinuousOptimizationToggle"]',
          ]),
          type: SPOTLIGHT_TYPE.rounded,
        },
      ],
    },
  },
];
